<template>
  <v-dialog v-model="dialog" width="500" 
    @keydown.esc="cancel"
  >
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        <span>{{title}}</span>
      </v-card-title>
      <v-card-text pa-1>
          <slot>{{$t('areYouSure')}}</slot>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-layout row justify-space-between pb-3>
          <v-btn color="grey-lighten-3" flat @click="cancel">{{cancelLabel || $t('cancel')}}</v-btn>
          <v-btn ref="ok" dark :color="color || 'primary'" @click="ok">{{label || $t('ok')}}</v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    props: ['title','label','cancelLabel', 'color'],
    data() { return {
        dialog: false
    }},
    methods: {
        open() {
            this.dialog = true
            this.$nextTick(() => this.$refs.ok.$el.focus())
            return new Promise((resolve) => {
                this.resolve = resolve
            })
        },
        cancel() {
            this.dialog = false
            this.$emit('cancel')
        },
        ok() {
            this.dialog = false
            this.$emit('ok')
            if (this.resolve) this.resolve()
        },
    }

}
</script>